import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { paymentScheduleEndpoints } from '@/lib/api/endpoints';
import { paymentScheduleKeys } from '@/lib/queryKeys';
import type { PaymentSchedule } from '@/types/paymentSchedule';

/**
 * Returns the active payment schedule for a job, or null if none exists.
 */
export function useJobPaymentSchedule(jobId: string | undefined) {
  return useApiQuery<PaymentSchedule | null>({
    queryKey: paymentScheduleKeys.byJob(jobId ?? 'none'),
    enabled: Boolean(jobId),
    queryFn: ({ signal }) =>
      apiGet<PaymentSchedule | null>(operationsClient, paymentScheduleEndpoints.byJob(jobId!), {
        signal,
      }),
  });
}
